/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_DescriptionInputs */

const en_guide_json_vs_yaml_xml_description = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare JSON, YAML, and XML data formats. Learn the strengths, weaknesses, and best use cases for each format.`)
};

const ko_guide_json_vs_yaml_xml_description = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, YAML, XML 데이터 포맷을 비교합니다. 각 포맷의 강점, 약점, 최적의 사용 사례를 알아보세요.`)
};

const ja_guide_json_vs_yaml_xml_description = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON、YAML、XMLデータ形式を比較します。各フォーマットの長所、短所、最適なユースケースを学びましょう。`)
};

/**
* | output |
* | --- |
* | "Compare JSON, YAML, and XML data formats. Learn the strengths, weaknesses, and best use cases for each format." |
*
* @param {Guide_Json_Vs_Yaml_Xml_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_description = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_description(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_description(inputs)
	return ja_guide_json_vs_yaml_xml_description(inputs)
});